import { createAxiosInstance } from './util'
import config from 'config'

export const apiAxios = createAxiosInstance({ url: config.apiUrl })
export const hotelInfoAxios = createAxiosInstance({ url: config.apiHotelInfo })
